import { render, staticRenderFns } from "./HelpCenterMenuManagement.vue?vue&type=template&id=af37227a&scoped=true"
import script from "./HelpCenterMenuManagement.vue?vue&type=script&lang=js"
export * from "./HelpCenterMenuManagement.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterMenuManagement.vue?vue&type=style&index=0&id=af37227a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af37227a",
  null
  
)

export default component.exports